/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DiscountResponse
 */
export interface DiscountResponse {
    /**
     * 
     * @type {string}
     * @memberof DiscountResponse
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscountResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscountResponse
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountResponse
     */
    'state'?: DiscountResponseStateEnum;
    /**
     * 
     * @type {number}
     * @memberof DiscountResponse
     */
    'percentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscountResponse
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscountResponse
     */
    'minPurchaseAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscountResponse
     */
    'maxDiscountAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscountResponse
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountResponse
     */
    'endDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscountResponse
     */
    'appliesToMealPrice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscountResponse
     */
    'appliesToDeliveryFee'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscountResponse
     */
    'availableForAppSale'?: boolean;
}

export const DiscountResponseStateEnum = {
    Active: 'ACTIVE',
    Expired: 'EXPIRED',
    Passive: 'PASSIVE'
} as const;

export type DiscountResponseStateEnum = typeof DiscountResponseStateEnum[keyof typeof DiscountResponseStateEnum];


